import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function PricingSection() {
  return <div className="w-full px-6 py-20 bg-gradient-to-b from-transparent via-purple-900/20 to-transparent" data-id="element-125">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-126">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-white" style={{
        fontFamily: 'Oswald, sans-serif'
      }} data-id="element-127">
          Surely This Would Be Expensive?
        </h2>
        <div className="space-y-6 text-lg text-gray-300 leading-relaxed font-light" data-id="element-128">
          <p data-id="element-129">
            This is the kind of magic our clients pay upwards of{' '}
            <span className="text-cyan-400 font-semibold" data-id="element-130">$40,000</span> for and
            commit to a 3+ month-long journey with one of our transformation
            programs.
          </p>
          <p data-id="element-131">
            But we have found a way to potentially give you some of this magic
            for a fraction of the cost and a fraction of the time.
          </p>
          <p className="text-xl font-medium text-white" data-id="element-132">
            You can get direct access to the Master's mind and finally get the
            clear roadmap showing you the exact next steps to achieve the
            results you've been searching for.
          </p>
          <div className="bg-slate-900/50 border border-purple-500/30 rounded-lg p-8 space-y-4" data-id="element-133">
            <p className="text-lg" data-id="element-134">And you know what?</p>
            <p data-id="element-135">
              If we charged{' '}
              <span className="text-cyan-400 font-semibold" data-id="element-136">$15k</span> for this
              and it transformed your health, it would be incredibly good value.
            </p>
            <p data-id="element-137">
              If we charged{' '}
              <span className="text-cyan-400 font-semibold" data-id="element-138">$10k</span> for this
              and it completely upgraded your life it would be INSANELY good
              value.
            </p>
            <p className="text-xl font-medium text-white pt-4" data-id="element-139">
              But the point of this is to give you the personalized guidance you
              need, and the confidence in what to do next…
            </p>
            <p data-id="element-140">
              Without necessarily requiring a 5-figure investment and 3+ months
              of time.
            </p>
          </div>
        </div>
        {/* Pricing Card */}
        <div className="relative" data-id="element-141">
          <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-cyan-600 rounded-2xl blur-xl opacity-50" data-id="element-142" />
          <div className="relative bg-gradient-to-br from-purple-900/90 to-cyan-900/90 border-2 border-cyan-400 rounded-2xl p-8 md:p-12 text-center space-y-6" data-id="element-143">
            <p className="text-xl text-gray-300 font-light" data-id="element-144">
              So, for a limited time:
            </p>
            <h3 className="text-4xl md:text-5xl font-bold text-white" style={{
            fontFamily: 'Oswald, sans-serif'
          }} data-id="element-145">
              Meeting With the Master
            </h3>
            <p className="text-2xl text-gray-300 font-light" data-id="element-146">
              Delivered in a single, powerful session
            </p>
            <div className="py-6" data-id="element-147">
              <p className="text-6xl md:text-7xl font-bold bg-gradient-to-r from-cyan-400 to-purple-400 bg-clip-text text-transparent" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-148">
                $1,500
              </p>
            </div>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto font-light" data-id="element-149">
              If you're ready to stop messing around with guesswork, and you're
              ready to find out exactly what to do next for YOUR unique
              situation and your unique biology, this is your opportunity.
            </p>
            <div className="pt-6 space-y-4" data-id="element-150">
              <p className="text-white font-medium" data-id="element-151">
                Click the following link to make the payment and book your
                Meeting With the Master:
              </p>
              <a href="https://go.peptidescienceinstitute.com/mwm" className="inline-flex items-center gap-2 px-10 py-5 bg-gradient-to-r from-purple-600 to-cyan-600 text-white text-xl font-bold rounded-lg hover:from-purple-500 hover:to-cyan-500 transition-all shadow-2xl shadow-purple-500/50 hover:shadow-purple-500/70" data-id="element-152">
                Book Your Meeting Now
                <ArrowRightIcon className="w-6 h-6" data-id="element-153" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
}